import { useGetPluginsStatus, getGetPluginsStatusQueryKey } from '@cdf/api-client-react';
import type { PluginsStatus } from '@cdf/api-client-react';

export interface UsePluginStatusResult {
  plugins: PluginsStatus | undefined;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Plugin registry status from the API. Cached aggressively — plugin
 * availability only changes when the server environment changes.
 */
export function usePluginStatus(): UsePluginStatusResult {
  const query = useGetPluginsStatus({
    query: { queryKey: getGetPluginsStatusQueryKey(), staleTime: 5 * 60_000, retry: 2 }
  });
  return {
    plugins: query.data,
    isLoading: query.isLoading,
    isError: query.isError
  };
}
